export const APP_ROUTES = {
    ROOT: "/",
    HOMEPAGE: "/homepage",
    REVIEWS: "/reviews",
    ABOUT_US: "/about-us",
    HOME: "/home",
    PORTAL_HOME: "/home-redesign",
    PORTAL_BILLING: "/home-redesign/billing",
    PORTAL_BILLING_INVOICE: "/home-redesign/billing/invoice",
    PORTAL_BILLING_CREDIT_NOTE: "/home-redesign/billing/credit-note",
    PORTAL_PROFILE: "/home-redesign/profile",
    PORTAL_REFER_FRIEND: "/home-redesign/refer-friend",
    PORTAL_TREATMENT: "/home-redesign/treatment",
    SIGN_IN: "/sign-in",
    CHECKOUT: "/checkout",
    REFER_FRIEND: "/refer-friend",
    LIVE_OFFICE_HOURS: "/live-office-hours",
    WEBINAR: "/webinar",
    SCIENCE: "/science",
    LIVE_INTRO_OFFICE_HOURS: "/live-intro-office-hours",
    POST_WEBINAR: "/post-webinar",
    PQP_POSTPARTUM: "/pqp/postpartum",
    PQP_UPSELL: "/pqp-upsell",
    PQP_HORMONE_IMBALANCE: "/pqp/hormone-imbalance",
    PQP_ENDOMETRIOSIS: "/pqp/endometriosis",
    PQP_OESTRA: "/pqp-oestra",
    PQP_OESTRA_MENOPAUSE: "/pqp-menopause",
    PQP_LIBIDA:"/pqp-libida",
    PQP_NAD:"/pqp-nad",
    PQP_ANTI_AGING_FACE_CREAM: "/pqp/anti-aging-face-cream",
    PQP_UPSELL_FACE_CREAM: "/pqp-upsell/face-cream",
    PQP_UPSELL_OESTRA_CREAM: "/pqp-upsell/oestra-cream",
    TREATMENT_HORMONE_IMBALANCE: "/treatment/hormone-imbalance",
    TREATMENT_ENDOMETRIOSIS: "/treatment/endometriosis",
    TREATMENT_MENOPAUSE: "/treatment/menopause",
    TREATMENT_PERIMENOPAUSE: "/treatment/perimenopause",
    BODYMATCHED_PERIMENOPAUSE_SKIN: "/bodymatched/perimenopause-skin",
    BODYMATCHED_ESTRIOL: "/bodymatched/estriol",
    BODYMATCHED_TRETINOIN: "/bodymatched/tretinoin",
    TREATMENT_PERIMENOPAUSE_AD: "/treatment/perimenopause/ad",
    TREATMENT_HRT: "/treatment/hrt",
    TREATMENT_HRT_3: "/treatment/hrt-3",
    TREATMENT_PCOS: "/treatment/pcos",
    TREATMENT_POSTPARTUM: "/treatment/postpartum",
    TREATMENT_TESTOSTERONE: "/treatment/testosterone",
    TREATMENT_BIOIDENTICAL_HRT: "/treatment/bioidentical-hrt",
    PRODUCT_PAGE: "/product-page",
    CHECKOUT_BILLING: "/checkout-billing",
    THANK_YOU: "/thank-you",
    THANKS_FOR_ID_UPLOAD: "/thanks-for-id-upload",
    OESTRA_REASONS: "/oestra-reasons",
    BODYMATCHED_7_REASONS: "/bodymatched/7-reasons",
    LIBIDA_7_REASONS: "/libida/7-reasons",
    LIBIDA_LP: "/sexual-wellness/libida",
    NAD_LP: "/p/longevity/nad",
    LIBIDA_LP_PT141: "/sexual-wellness/libida/pt-141",
    LIBIDA_LP_SCREAM: "/sexual-wellness/libida/arousal-cream-alternative",
    LIBIDA_AD: "/libida/ad",
    MENOPAUSE_AD: "/menopause/ad",
    FINASTERIDE: "/bodymatched/finasteride",
    NIACINAMIDE: "/bodymatched/niacinamide",
    PERI_LABS: "/perimenopause-labs",
    MENOPAUSE_WEIGHT_GAIN: "/menopause-weight-gain",
    TREATMENT_HRT_LIBIDO: "/treatment/hrt-libido",
    COMPARE_MIDI_HEALTH: "/compare/inner-balance-vs-midi-health",
    COMPARE_HONE_HEALTH: "/compare/inner-balance-vs-hone-health",
    COMPARE_ALLOY_HEALTH: "/compare/inner-balance-vs-alloy",
    COMPARE_WINONA_HEALTH: "/compare/inner-balance-vs-winona",
    AMBASSADOR: "/ambassador-program",
} as const;
